import { render } from "./WohnungStep8a.vue?vue&type=template&id=53f45fe8"
import script from "./WohnungStep8a.vue?vue&type=script&lang=js"
export * from "./WohnungStep8a.vue?vue&type=script&lang=js"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__